import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { StoreService } from '../store.service';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';
import { MenuItem } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';

@Component({
  selector: 'app-map-account',
  templateUrl: './map-account.component.html',
  styleUrls: ['./map-account.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService, ConfirmationService]
})
export class MapAccountComponent implements OnInit {

  activeIndex: number = 0;
  steps: MenuItem[];
  qboVendAcctDefault: any = [];
  qboSelectedVendor: any = [];
  qboVendors: SelectItem[] = [];
  // rahAccounts: SelectItem[] = [];
  qboTax: SelectItem[] = [];
  qboClass: SelectItem[] = [];
  qboAccountIDSelected: any = 0;

  qboTaxSelected: any = "";
  qboClassSelected: any = "";
  msgs: Message[] = [];
  loadingMessage: any = "";
  text: string;
  qboaccountsTemp: any = [];
  results: string[];
  selectedCountry: any;
  filteredSuppliers: any[];
  selectedSupplier: any[];
  filteredAccount: any[];
  filteredClass: any[];
  tampqboVendors: any[];
  tampqboTax: any[];
  tmpClass : any[];
  syncCustomer:boolean=false;
  QboCustomer:any=[];
  tampqboCustomer: any[];
  qboSelectedCustomer: any[] = [];
  qboCustomerAcctDefault:any[];
  constructor(private router: Router, private api: ApiService, private spinner: NgxSpinnerService, private ss: StoreService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.ss.storePageName('/mapaccount');
    this.syncCustomer = this.ss.fetchSyncCustomer()
    console.log("QboCustomer-->",this.QboCustomer)
    if( this.syncCustomer){
      this.bindCustomer();

    }else{
      this.bindVendor();
      

    }
    this.bindTax();
    this.bindAccounts();
    this.bindClasses();
    

    this.steps = [
      {
        label: 'Map Supplier Default Account',

        
        command: (event: any) => {
          this.ss.storePageName('/mapaccount');
          this.activeIndex = 0;
          this.router.navigateByUrl('/mapaccount');
        }
      },
      {
        label: 'Upload Document',
        command: (event: any) => {
          this.ss.storePageName('/docupload');
          this.activeIndex = 1;
          this.router.navigateByUrl('/docupload');
        }
      },
      {
        label: 'Review and Approve',
        command: (event: any) => {
          this.ss.storePageName('/docreview');
          this.activeIndex = 2;
          this.router.navigateByUrl('/docreview');
        }
      },
      {
        label: 'Post To Accounting System',
        command: (event: any) => {
          this.ss.storePageName('/docpost');
          this.activeIndex = 3;
          this.router.navigateByUrl('/docpost');
        }
      }
    ];


  }

  bindTax() {

    this.tampqboTax = this.ss.fetchQboSalesTax();
    console.log('this.tampqboTax ');
    console.log(this.tampqboTax );
    if(this.tampqboTax == null) return;
    this.qboTax.push({ label: '', value: '' });

    this.tampqboTax .forEach(element => {
      this.qboTax.push({ label: element.Name, value: element.Name });
    });
  }

  // syncVendorFromRAH() {
  //   this.loadingMessage = "Sync All Vendor...";
  //   this.spinner.show();
  //   this.api.post('Rah/SyncAllVendor', "").subscribe(
  //     (res: {}) => this.succes_syncVendorFromRAH(res),
  //     error => this.failed_syncVendorFromRAH(<any>error));
  // }

  // succes_syncVendorFromRAH(resp: any) {
  //   this.spinner.hide();
  //   this.getVendor();
  // }

  // failed_syncVendorFromRAH(resp: any) {
  //   this.spinner.hide();
  //   this.getVendor();

  // }

  filterSupplier(event) {

    let filtered: any[] = [];
    var query = event.query;

    if (query == null || query.length == 0) {
      this.qboSelectedVendor = this.qboVendAcctDefault;
    } else {
      for (let i = 0; i < this.qboVendAcctDefault.length; i++) {
        let acct = this.qboVendAcctDefault[i];
        if (acct.FullName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
          filtered.push(acct);
        }
      }
      this.filteredSuppliers = filtered;
      this.qboSelectedVendor = this.filteredSuppliers;
    }


  }

  // getVendor() {
  //   this.spinner.show();
  //   this.loadingMessage = "Get Vendor...";
  //   this.api.get('Rah/GetAllQboVendor', '').subscribe(
  //     (res: {}) => this.success_getVendor(res),
  //     error => this.failed_getVendor(<any>error));
  // }

  // success_getVendor(resp: any) {
  //   this.spinner.hide();
  //   this.ss.storeQboVendors(resp.Data);
  //   this.qboVendAcctDefault = resp.Data;
  //   this.qboSelectedVendor = this.qboVendAcctDefault;
  // }

  // failed_getVendor(resp: any) {
  //   this.spinner.hide();
  // }

  bindAccounts() {

    this.qboaccountsTemp = this.ss.fetchQboAccount();
    // if(tmpAccounts == null) return;
    // this.rahAccounts.push({ label: '', value: '' });

    // tmpAccounts.forEach(element => {
    //   this.rahAccounts.push({ label: element.FullName, value: element.ListID });
    // });
  }

  filterAccount(event) {

    let filtered: any[] = [];
    let query = event.query;
    if (query == null || query.length >= 3) {
    for (let i = 0; i < this.qboaccountsTemp.length; i++) {
      let country = this.qboaccountsTemp[i];
      if(country.FullName.toLowerCase().includes(event.query.toLowerCase())){
        filtered.push(country);
        }
    }
  }

    this.filteredAccount = filtered;
  }

  onChangeAccount(event: any, hdr: any) {
    if (this.syncCustomer){
        
        var acct = this.qboaccountsTemp.find(xx => xx.ListID == event.ListID);
        hdr.AccountFullName = acct.FullName;
        hdr.AccountListID = acct.ListID;
        var vend = this.tampqboCustomer.find(xx => xx.ListID == hdr.ListID);
        vend.AccountFullName = acct.FullName;
        vend.AccountListID = acct.ListID;
        this.ss.storeQboCustomers(this.tampqboCustomer);
        this.api.post('Rah/SaveCustomerAcctDefault', hdr).subscribe(
            (res1: {}) => this.successAccount(res1),
            error => this.failedSaveAll(<any>error));
    }
    else{

    var acct = this.qboaccountsTemp.find(xx => xx.ListID == event.ListID);
    hdr.AccountFullName = acct.FullName;
    hdr.AccountListID = acct.ListID;

     var vend = this.tampqboVendors.find(xx => xx.ListID == hdr.ListID);
     vend.AccountFullName = acct.FullName;
     vend.AccountListID = acct.ListID;
     this.ss.storeQboVendors(this.tampqboVendors);

      this.api.post('Rah/SaveVendAcctDefault', hdr).subscribe(
        (res1: {}) => this.successAccount(res1),
        error => this.failedSaveAll(<any>error));
      
    }
  }

  successAccount(resp: any) {
   
  }

  bindClasses() {
    this.tmpClass = this.ss.fetchQboClass();
    // if (this.tmpClass  == null) return;
    // this.qboClass.push({ label: '', value: '' });

    // this.tmpClass .forEach(element => {
    //   this.qboClass.push({ label: element.FullName, value: element.ListID });
    // });
  }

  filterClass(event) {

    let filtered: any[] = [];
    let query = event.query;
    if (query == null || query.length >= 3) {
    for (let i = 0; i < this.tmpClass.length; i++) {
      let country = this.tmpClass[i];
      // if (country.FullName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
      //   filtered.push(country);
      // }

      if(country.FullName.toLowerCase().includes(event.query.toLowerCase())){
        filtered.push(country);
        }
    }
  }

    this.filteredClass = filtered;
  }

  onChangeClass(event: any, hdr: any) {
    var acct = this.tmpClass.find(xx => xx.ListID == event.ListID);
    hdr.ClassFullName = acct.FullName;
    hdr.ClassListID = acct.ListID;


    var vend = this.tampqboVendors.find(xx => xx.ListID == hdr.ListID);
    vend.ClassFullName = acct.FullName;
    vend.ClassListID = acct.ListID;
    this.ss.storeQboVendors(this.tampqboVendors);



    this.api.post('Rah/SaveQboVendClassDefault', hdr).subscribe(
      (res1: {}) => this.successSaveAll(res1),
      error => this.failedSaveAll(<any>error));
  }

  


  bindVendor() {

    this.tampqboVendors  = this.ss.fetchQboVendors();
    if (this.tampqboVendors == null){
      this.bindVendAcctDefault();
      return;
    };
    this.qboVendAcctDefault = this.tampqboVendors;
    this.qboSelectedVendor = this.tampqboVendors;
  }

  bindCustomer() {
    this.tampqboCustomer = this.ss.fetchQboCustomers();
    if (this.tampqboCustomer == null){
      this.spinner.show();
      this.api.get('Rah/GetAllQboCustomer', '').subscribe(
        (res: {}) => this.success_getCustomer(res),
        error => this.failed_getCustomer(<any>error));
      return;
    }
    this.QboCustomer = this.tampqboCustomer;
    this.qboCustomerAcctDefault = this.tampqboCustomer;
    this.qboSelectedCustomer = this.tampqboCustomer;
}

  success_getCustomer(resp: any) {
    
    this.QboCustomer = resp.Data
    this.qboCustomerAcctDefault = this.QboCustomer;
    this.qboSelectedCustomer = this.QboCustomer
    this.ss.storeQboCustomers(resp.Data);
    this.spinner.hide();
    console.log("success_getCustomer",this.QboCustomer)
  }

  failed_getCustomer(resp: any) {
    this.spinner.hide();
  }

  bindVendAcctDefault() {


    this.spinner.show();

    this.api.get('Rah/GetAllQboVendor', '').subscribe(
      (res: {}) => this.sucessGetVendAcct(res),
      error => this.failedGetVendAcct(<any>error));
  }

  sucessGetVendAcct(resp: any) {
    this.spinner.hide();
    this.qboVendAcctDefault = resp.Data;
    this.qboSelectedVendor = this.qboVendAcctDefault;
    console.log('this.qboSelectedVendor');
    console.log(this.qboSelectedVendor);
  }

  failedGetVendAcct(resp: any) {
    this.spinner.hide();
  }


  validateAccount(resp: any) {
    this.msgs = [];
    this.spinner.hide();
  }

  confirm() {
    if (this.qboAccountIDSelected == 0) {
      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select a account first', detail: 'Mandatory.' });
      return;
    }

    if (this.qboVendAcctDefault.find(xx => xx.Select == true) == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select atleast a Suppliers first', detail: 'Mandatory.' });
      return;
    }



    this.confirmationService.confirm({
      message: 'Are you sure that you want to assgin selected Account as default account for all the suppliers selected in below grid',
      accept: () => {

        this.spinner.show();
        this.loadingMessage = "Saving changes...";

        this.qboVendAcctDefault.forEach(element => {
          if (element.Select) {
            element.AccountListID = this.qboAccountIDSelected;
          }

        });

        //Actual logic to perform a confirmation
        //Approve the bill

        this.api.post('Rah/SaveAllVendAcctDefault', this.qboVendAcctDefault).subscribe(
          (res1: {}) => this.successSaveAll(res1),
          error => this.failedSaveAll(<any>error));
      },
      reject: () => {
        this.qboAccountIDSelected = 0;
      }
    });
  }

  UnmapSelectedAccount() {
    if (this.qboVendAcctDefault.find(xx => xx.Select == true) == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select atleast a Suppliers first', detail: 'Mandatory.' });
      return;
    }



    this.confirmationService.confirm({
      message: 'Are you sure that you want to Unmap Account for all the suppliers selected in below grid',
      accept: () => {

        this.spinner.show();
        this.loadingMessage = "Saving changes...";

        this.qboVendAcctDefault.forEach(element => {
          if (element.Select) {
            element.AccountListID = "";
          }

        });

        //Actual logic to perform a confirmation
        //Approve the bill

        this.api.post('Rah/SaveAllVendAcctDefault', this.qboVendAcctDefault).subscribe(
          (res1: {}) => this.successSaveAll(res1),
          error => this.failedSaveAll(<any>error));
      },
      reject: () => {
        this.qboAccountIDSelected = 0;
      }
    });
  }

  UnmapSelectedTax() {
    if (this.qboVendAcctDefault.find(xx => xx.Select == true) == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select atleast a Suppliers first', detail: 'Mandatory.' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Are you sure that you want to Unmap tax for all the suppliers selected in below grid',
      accept: () => {

        this.spinner.show();
        this.loadingMessage = "Saving changes...";
        this.qboVendAcctDefault.forEach(element => {
          if (element.Select) {
            element.TaxName = "";
          }
        });

        //Actual logic to perform a confirmation
        //Approve the bill

        this.api.post('Rah/SaveAllVendTaxDefault', this.qboVendAcctDefault).subscribe(
          (res1: {}) => this.successSaveAll(res1),
          error => this.failedSaveAll(<any>error));
      },
      reject: () => {
        //this.qboTaxSelected = 0;
      }
    });
  }


  successSaveAll(resp: any) {
    this.spinner.hide();
    this.qboVendAcctDefault.forEach(element => {
      element.Select = false;
    });
  }

  failedSaveAll(resp: any) {
    this.spinner.hide();
  }


  onQboVendAcctSelect(event) {

    // this.qboDocumentSelected = event.data;
    // this.qboVendorSelected.QboVendorID = this.qboDocumentSelected.QboVendorID;
    // this.qboDocumentLines = event.data.DocumentLine;
  }

  onChangeSelect(event: any, hdr: any) {
    hdr.Select = event.target.checked;
  }

  UnmapTax(hdr: any) {
    this.loadingMessage = "Unmapping...";
    this.spinner.show();
    hdr.TaxName = '';

    var vend = this.tampqboVendors.find(xx => xx.ListID == hdr.ListID);
    vend.TaxName = '';
  
    this.ss.storeQboVendors(this.tampqboVendors);

    this.api.post('Rah/DeleteVendTaxDefault', hdr).subscribe(
      (res1: {}) => this.successDeleteMapping(res1, hdr),
      error => this.failedDeleteMapping(<any>error));
  }

  successDeleteMapping(resp: any, hdr) {
    this.spinner.hide();
    hdr.TaxName = "";
  }

  failedDeleteMapping(resp: any) {
    this.spinner.hide();
    this.msgs = [];
    this.msgs.push({ severity: 'Info', summary: 'Issue In UnMap Tax...', detail: 'Mandatory.' });
    return;
  }

  UnmapAccount(hdr: any) {
    this.loadingMessage = "Unmapping...";
    this.spinner.show();

    hdr.AccountFullName = '';
    hdr.AccountListID = '';

    var vend = this.tampqboVendors.find(xx => xx.ListID == hdr.ListID);
    vend.AccountFullName = '';
    vend.AccountListID = '';
    this.ss.storeQboVendors(this.tampqboVendors);

    this.api.post('Rah/DeleteVendAcctDefault', hdr).subscribe(
      (res1: {}) => this.successDeleteAccountMapping(res1, hdr),
      error => this.failedDeleteAccountMapping(<any>error));
  }
  successDeleteAccountMapping(resp: any, hdr) {
    this.spinner.hide();
    hdr.AccountListID = "";
  }

  failedDeleteAccountMapping(resp: any) {
    this.spinner.hide();
    this.msgs = [];
    this.msgs.push({ severity: 'Info', summary: 'Issue In UnMap Account...', detail: 'Mandatory.' });
    return;
  }



  onChangeTax(event: any, hdr: any) {
    console.log(event);

    this.api.post('Rah/SaveQboVendTaxDefault', hdr).subscribe(
      (res1: {}) => this.successSaveAll(res1),
      error => this.failedSaveAll(<any>error));
  }

 
  onChangeSelectAll(event: any) {
    const mappedRows = this.syncCustomer ? this.qboSelectedCustomer : this.qboVendAcctDefault;
    if (!mappedRows) return;
    mappedRows.forEach(element => {
      element.Select = event.target.checked;
    });
  }

  UnmapClass(hdr: any) {
    this.loadingMessage = "Unmapping...";
    this.spinner.show();

    hdr.ClassFullName = '';
    hdr.ClassListID = '';

    var vend = this.tampqboVendors.find(xx => xx.ListID == hdr.ListID);
    vend.ClassFullName = '';
    vend.ClassListID = '';
    this.ss.storeQboVendors(this.tampqboVendors);
	

    this.api.post('Rah/DeleteVendClassDefault', hdr).subscribe(
      (res1: {}) => this.successClassDeleteMapping(res1, hdr),
      error => this.failedClassDeleteMapping(<any>error));
  }

  successClassDeleteMapping(resp: any, hdr) {
    this.spinner.hide();
    hdr.ClassName = "";
  }


  failedClassDeleteMapping(resp: any) {
    this.spinner.hide();
    this.msgs = [];
    this.msgs.push({ severity: 'Info', summary: 'Issue In Unmap Class...', detail: 'Mandatory.' });
    return;
  }

  UnmapSelectedCustomerAccount() {
    if (this.QboCustomer.find(xx => xx.Select == true) == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select atleast a Customer first', detail: 'Mandatory.' });
      return;
    }



    this.confirmationService.confirm({
      message: 'Are you sure that you want to Unmap Account for all the suppliers selected in below grid',
      accept: () => {

        this.spinner.show();
        this.loadingMessage = "Saving changes...";

        this.qboVendAcctDefault.forEach(element => {
          if (element.Select) {
            element.AccountListID = "";
          }

        });

        //Actual logic to perform a confirmation
        //Approve the bill

        this.api.post('Rah/SaveAllVendAcctDefault', this.qboVendAcctDefault).subscribe(
          (res1: {}) => this.successSaveAll(res1),
          error => this.failedSaveAll(<any>error));
      },
      reject: () => {
        this.qboAccountIDSelected = 0;
      }
    });
  }

  
  UnmapSelectedTaxForCustomer() {
    if (this.qboVendAcctDefault.find(xx => xx.Select == true) == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select atleast a Customer first', detail: 'Mandatory.' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Are you sure that you want to Unmap tax for all the Customer selected in below grid',
      accept: () => {

        this.spinner.show();
        this.loadingMessage = "Saving changes...";
        this.qboVendAcctDefault.forEach(element => {
          if (element.Select) {
            element.TaxName = "";
          }
        });

        //Actual logic to perform a confirmation
        //Approve the bill

        // this.api.post('Rah/SaveAllVendTaxDefault', this.qboVendAcctDefault).subscribe(
        //   (res1: {}) => this.successSaveAll(res1),
        //   error => this.failedSaveAll(<any>error));
      },
      reject: () => {
        //this.qboTaxSelected = 0;
      }
    });
  }

}
